import { render, staticRenderFns } from "./accountStatementsDetail.vue?vue&type=template&id=70f412b0&scoped=true"
import script from "./accountStatementsDetail.vue?vue&type=script&lang=js"
export * from "./accountStatementsDetail.vue?vue&type=script&lang=js"
import style0 from "./accountStatementsDetail.vue?vue&type=style&index=0&id=70f412b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f412b0",
  null
  
)

export default component.exports